import request from '@/utils/request'

export function loginApi (data) {
    return request({
        url: '/login',
        method: 'post',
        data
    })
}
export function storeList (data) {
    return request({
        url: '/store/list',
        method: 'get',
        data
    })
}